import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [currentCompany, setCurrentCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyId = localStorage.getItem('companyId');
        if (!companyId) {
          console.error('Company ID non trovato');
          return;
        }
        const response = await api.get(`/companies/${companyId}`);
        setCurrentCompany(response.data);
      } catch (error) {
        console.error('Errore nel caricamento dei dati aziendali:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  return (
    <CompanyContext.Provider value={{ currentCompany, loading }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany deve essere usato all\'interno di un CompanyProvider');
  }
  return context;
};

export default CompanyContext; 